import {
  Component,
  Input,
  OnInit,
  AfterViewInit,
  Pipe,
  PipeTransform,
  ElementRef,
  ViewChild,
} from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AngularEditorConfig } from "@kolkov/angular-editor";
import { first } from "rxjs/operators";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { GestionFichierService } from "src/app/core/services/business/service/gestion-fichier.service";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-doc-viewer-modal",
  templateUrl: "./doc-viewer-modal.component.html",
  styleUrls: ["./doc-viewer-modal.component.scss"],
})
export class DocViewerModalComponent implements OnInit {
  url: any;
  destination: any;
  @Input() subitemId;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private sanitizer: DomSanitizer,
    private el: ElementRef,
    private _gestionFichierService: GestionFichierService
  ) {}

  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  ngOnInit() {
    this.downloadFile(this.subitemId);
  }

  downloadFile(subitemId: string) {
    this.url =
      environment.BACKEND_RACINE_URL +
      "gestion-fichier/download?subitemid=" +
      subitemId;
  }
}
